import type React from 'react';

interface LinkedInIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function LinkedInIcon({ size = 24, ...props }: LinkedInIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.2453 1.75H2.75469C2.2 1.75 1.75 2.2 1.75 2.75469V13.2453C1.75 13.8 2.2 14.25 2.75469 14.25H13.2453C13.8 14.25 14.25 13.8 14.25 13.2453V2.75469C14.25 2.2 13.8 1.75 13.2453 1.75ZM13.2453 13.25C6.24844 13.2484 2.75 13.2453 2.75 13.2453C2.75156 6.24844 2.75469 2.75 2.75469 2.75C9.75156 2.75156 13.25 2.75469 13.25 2.75469C13.2484 9.75156 13.2453 13.25 13.2453 13.25ZM3.60313 6.43594H5.45781V12.4016H3.60313V6.43594ZM4.53125 5.62031C5.12344 5.62031 5.60625 5.13906 5.60625 4.54531C5.60625 4.40414 5.57844 4.26435 5.52442 4.13393C5.4704 4.0035 5.39121 3.885 5.29139 3.78517C5.19157 3.68535 5.07306 3.60617 4.94263 3.55214C4.81221 3.49812 4.67242 3.47031 4.53125 3.47031C4.39008 3.47031 4.25029 3.49812 4.11987 3.55214C3.98944 3.60617 3.87093 3.68535 3.77111 3.78517C3.67129 3.885 3.5921 4.0035 3.53808 4.13393C3.48406 4.26435 3.45625 4.40414 3.45625 4.54531C3.45469 5.13906 3.93594 5.62031 4.53125 5.62031ZM8.47344 9.45C8.47344 8.67188 8.62187 7.91875 9.58594 7.91875C10.5359 7.91875 10.55 8.80781 10.55 9.5V12.4016H12.4031V9.12969C12.4031 7.52344 12.0562 6.2875 10.1797 6.2875C9.27812 6.2875 8.67344 6.78281 8.425 7.25156H8.4V6.43594H6.62031V12.4016H8.47344V9.45Z"
        fill="currentColor"
      />
    </svg>
  );
}
